export const config: IConfigs = {
    baseApiUrl: (window as any).REACT_APP_BASE_API_URL || process.env.REACT_APP_BASE_API_URL || "https://cieri.ai/api/v1",
    slackConnectRedirectUrl: (window as any).REACT_APP_SLACK_URL || process.env.REACT_APP_SLACK_URL || "",
    swrlDocsUrl: 'https://docs.aptori.dev',
    mixpanelToken: (window as any).REACT_APP_MIXPANEL_TOKEN || process.env.REACT_APP_MIXPANEL_TOKEN || "",
    sentryDsn: (window as any).REACT_APP_SENTRY_DSN ||process.env.REACT_APP_SENTRY_DSN || "",
    experimentalFeatures: process.env.REACT_APP_EXPERIMENTAL_FEATURES === 'true',
    isOmnibus: process.env.REACT_APP_OMNIBUS === 'true'
}
